import styled from 'styled-components';

export const MobileWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export const DesktopWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
